<template>
    <div class="header" style="width:100%">
        <div class="header_main_English" v-if="title=='English'">
            <div :style="{width:widths}"></div>
            <div class="img_box">
                <router-link to='/' exact>
                    <img src="http://www.ispunion.org/logo1.png" alt="" />
                </router-link>
            </div>
        </div>
        <div class="header_main" v-else>
            <div class="img_box">
                <router-link to='/' exact>
                    <img src="http://www.ispunion.org/logo1.png" alt="" />
                </router-link>
            </div>
        </div>
            <ul class="nav_list_English" v-if="title=='English'">
                <!-- <li><router-link to='/home' exact>首页</router-link></li>
                <li><router-link to='/union' exact>关于联盟</router-link></li>
                <li><router-link to='/company' exact>成员单位</router-link></li>
                <li><router-link to='/aboutAlliances' exact>展览交流</router-link></li>
                <li><router-link to='/forumArticles' exact>论坛文章</router-link></li>
                <li><router-link to='/works' exact>作品展示</router-link></li>
                <li><router-link to='/member' exact>会员申请</router-link></li>
                <li><router-link to='/sponsor' exact>诚邀赞助</router-link></li>
                <li><router-link to='/contact' exact>联系我们</router-link></li> -->
                <li  v-for="nav in navs" :key='nav.id'><router-link :to='nav.path'  exact><i class="el-icon-caret-right"></i>{{nav.title}}</router-link></li>
                <li><div class="en" @click="changeLang">{{title}}</div></li>
        <!-- <router-view v-if="isRouterAlives"/> -->
            </ul>
            <ul class="nav_list" v-else>
                <!-- <li><router-link to='/home' exact>首页</router-link></li>
                <li><router-link to='/union' exact>关于联盟</router-link></li>
                <li><router-link to='/company' exact>成员单位</router-link></li>
                <li><router-link to='/aboutAlliances' exact>展览交流</router-link></li>
                <li><router-link to='/forumArticles' exact>论坛文章</router-link></li>
                <li><router-link to='/works' exact>作品展示</router-link></li>
                <li><router-link to='/member' exact>会员申请</router-link></li>
                <li><router-link to='/sponsor' exact>诚邀赞助</router-link></li>
                <li><router-link to='/contact' exact>联系我们</router-link></li> -->
                <li  v-for="nav in navs" :key='nav.id'><router-link :to='nav.path'  exact><i class="el-icon-caret-right"></i>{{nav.title}}</router-link></li>
                <li><div class="en" @click="changeLang">{{title}}</div></li>
        <!-- <router-view v-if="isRouterAlives"/> -->
            </ul>
            <div style="flex:1" ref="content" :style="{width:widths}"></div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:"English", 
                widths:''
            }
        },
        computed:{
            navs(){
                return [
                    { id:1, path:'/home', title:this.$t('navs.nav1')},
                    { id:2, path:'/union', title:this.$t('navs.nav2')},
                    { id:3, path:'/company', title:this.$t('navs.nav3')},
                    { id:4, path:'/aboutAlliances', title:this.$t('navs.nav4'),},
                    // { id:4, path:'/aboutAlliances/aboutAlliances1', title:this.$t('navs.nav4')},
                    { id:5, path:'/forumArticles', title:this.$t('navs.nav5')},
                    { id:6, path:'/works', title:this.$t('navs.nav6')},
                    { id:7, path:'/member', title:this.$t('navs.nav7')},
                    { id:8, path:'/sponsor', title:this.$t('navs.nav8')},
                    { id:9, path:'/contact', title:this.$t('navs.nav9')},
                ]
            }       
        },
        created(){
            if(sessionStorage.getItem('chOrEn')==0){
                this.title="中文"
            }
            if(sessionStorage.getItem('chOrEn')==1){
                this.title="English"
            }
        },
        methods:{
            changeLang(){
                if(this.title=="English"){
                    this.title="中文"
                }else{
                    this.title="English"
                }
                let chOrEn
            let locale = this.$i18n.locale
            locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh';
            locale === 'zh' ? chOrEn = '0' : chOrEn = '1';
            sessionStorage.setItem('lang',this.$i18n.locale)
            sessionStorage.setItem('chOrEn',chOrEn)
            //   this.$router.go(0)
            if(this.$route.name=="forumArticles2"){
                this.$router.push({
                path: '/forumArticles',
                })
            }else if(this.$route.name=="aboutAlliances1"){
                this.$router.push({
                path: '/aboutAlliances',
                })
            }else{
                this.$router.go(0)
            }
            // this.reload();
            //   debugger
            //   console.log("差",this.$route.path)
            //   console.log("差123",window.location.href)
            }
        },
        mounted(){
            setTimeout(()=>{
            // debugger
                this.widths=(this.$refs.content.clientWidth/2)+"px"
            },20)
        }
    }
</script>

<style lang="less" scoped>
.header{
    width: 100%;
    height: 110px;
    background: #1E2C47;
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    position: fixed;
    left:0;
    top:0;
    z-index: 66;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .header_main_English{
        // width: 30%;
        height: 118px;
        background: url('../assets/img/yao.png') no-repeat;
        // position: absolute;
        // left:0;
        // top:0;
        background-size: 100% 100%;
        // z-index: 68;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 4%;
        // margin:0 auto;
       .img_box{
            width: 245px;
            height: 80px;
            a{
                display: block;
                width: 100%;
                height: 100%;
                color: #1C1C1C;
                img{
                width: 100%;
                height: 100%;
                }
            } 
       }
    }
    .header_main{
        width: 19%;
        height: 118px;
        background: url('../assets/img/yao.png') no-repeat;
        position: absolute;
        left:0;
        top:0;
        background-size: 100% 100%;
        z-index: 68;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 4%;
        // margin:0 auto;
       .img_box{
            width: 245px;
            height: 80px;
            a{
                display: block;
                width: 100%;
                height: 100%;
                color: #1C1C1C;
                img{
                width: 100%;
                height: 100%;
                }
            } 
       }
    }
}
        .nav_list_English{
        //    flex: 1;
            height: 110px;
            display: flex;
            // padding-left: 30%;
            align-items: center;
            box-sizing: border-box;
            justify-content:flex-start;
            font-size:17px;
            // font-weight: bold;
            //  height: 100%;
            li{
                padding:0 10px;
                height: 100%;
                // min-width: 100px;
                line-height: 110px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                a{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    line-height: 30px;
                    color: rgba(255, 255, 255, 0.7);
                }
                .en{
                    width: 60px;
                    height: 26px;
                    background: #fff;
                    color: #0a2f8e;
                    font-size:18px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 26px;
                    border-radius: 5px;
                    cursor: pointer;
                }
            }
            li:hover{
                a{
                    color: #fff;
                    font-weight: 800;
                }
            }
        }
        .nav_list{
        //    flex: 1;
            height: 110px;
            display: flex;
            padding-left: 19%;
            align-items: center;
            box-sizing: border-box;
            justify-content:space-around;
            font-size:17px;
            // font-weight: bold;
            //  height: 100%;
            li{
                padding:0 10px;
                height: 100%;
                // min-width: 100px;
                line-height: 110px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                a{
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 100%;
                    line-height: 30px;
                    color: rgba(255, 255, 255, 0.7);
                }
                .en{
                    width: 60px;
                    height: 26px;
                    background: #fff;
                    color: #0a2f8e;
                    font-size:18px;
                    font-weight: bold;
                    text-align: center;
                    line-height: 26px;
                    border-radius: 5px;
                    cursor: pointer;
                }
            }
            li:hover{
                a{
                    color: #fff;
                    font-weight: 800;
                }
            }
        }
.router-link-active{
  font-weight: 900;
  color: #fff!important;
  border-bottom: 3px solid #fff;
  box-sizing: border-box;
}
</style>